import { render, staticRenderFns } from "./ChooseCurrencies.vue?vue&type=template&id=0ffee937&"
import script from "./ChooseCurrencies.vue?vue&type=script&lang=js&"
export * from "./ChooseCurrencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ffee937')) {
      api.createRecord('0ffee937', component.options)
    } else {
      api.reload('0ffee937', component.options)
    }
    module.hot.accept("./ChooseCurrencies.vue?vue&type=template&id=0ffee937&", function () {
      api.rerender('0ffee937', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/ChooseCurrencies.vue"
export default component.exports